import type { ISwSettings } from "app/@types/ISwSettings";
import { isNoTouchOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const initCello = (swSettings: ISwSettings) => {
    if (!isNoTouchOrAfterTrial(swSettings)) {
        return;
    }

    const isProduction = window.location.host === "pro.similarweb.com";
    const celloUrl = isProduction
        ? "https://assets.cello.so/app/latest/cello.js"
        : "https://test.groupbuyclub.net/_sub_cello_assets/app/latest/cello.js";

    const script = document.createElement("script");

    script.type = "module";
    script.src = celloUrl;
    script.async = true;
    document.head.appendChild(script);
};
